var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtdamounticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9205 24.25C7.82904 24.25 4.78458 24.25 2.89229 22.3577C1 20.468 1 17.4235 1 11.3333V7.386C1 5.04033 1 3.8675 1.49083 2.98658C1.84105 2.35893 2.35893 1.84105 2.98658 1.49083C3.8675 1 5.04033 1 7.38858 1C8.89208 1 9.64383 1 10.3013 1.24671C11.8035 1.80988 12.4235 3.17517 13.1016 4.53012L13.9205 6.16667M7.45833 6.16667H20.056C22.7775 6.16667 24.1376 6.16667 25.1167 6.82025C25.5399 7.10266 25.9033 7.46563 26.1862 7.88846C26.6951 8.65054 26.8062 9.64513 26.832 11.3333M20.0353 18.019V16.2223C20.0353 15.9562 20.0469 15.6875 20.1412 15.4408C20.3944 14.7808 21.0647 13.9167 22.2854 13.9167C23.506 13.9167 24.2022 14.7808 24.4554 15.4408C24.551 15.6875 24.5613 15.9575 24.5613 16.2223V18.0177M20.1257 25.5417H24.498C25.7858 25.5417 26.8295 24.4993 26.8295 23.2141V20.6282C26.8295 19.343 25.7858 18.3006 24.498 18.3006H20.1257C18.8379 18.3006 17.7942 19.343 17.7942 20.6282V23.2141C17.7942 24.4993 18.8379 25.5417 20.1257 25.5417Z",
    stroke: "#FAF6F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtdamounticon);
export default __webpack_public_path__ + "static/media/ftdamounticon.c8e844444ef73349b8242e853ade2831.svg";
export { ForwardRef as ReactComponent };